// extracted by mini-css-extract-plugin
export default {"pre":"integration_pre__tsG0M","filter_section":"integration_filter_section__5o+mK"};